export default __webpack_public_path__ + "static/og_image-2db884fc35678d74fcb2588947a432e6.jpg";